import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TechTeamComponent } from './tech-team/tech-team.component';
import { I18nModule, ConfigModule } from '@spartacus/core';
import { PageLayoutModule, OutletModule, OutletRefModule, PageSlotModule, MediaModule } from '@spartacus/storefront';



@NgModule({
  declarations: [
    TechTeamComponent
  ],
  imports: [
    CommonModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    PageSlotModule,
    I18nModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        TechTeamFlexComponent: {
          component: TechTeamComponent
        }
      }
    })
  ]
})
export class TechTeamModule { }
